
export default class OrganizationError extends Error
{
}
